import { put, call, fork, select, takeEvery, all } from 'redux-saga/effects';

import * as impressionsReportsModule from '../modules/impressionsReports.module';
import * as Api from '../../core/api';

export function* fetchImpressionsCount() {
  const filter = yield select(state => state.impressionsReports.filter);

  const { response, error } = yield call(Api.impressionsReports.fetchImpressionsCount, { filter });

  if (response) {
    yield put(impressionsReportsModule.fetchImpressionsCountSuccess(response));
  } else {
    yield put(impressionsReportsModule.fetchImpressionsCountFail(error));
  }
}
export function* watchFetchImpressionsCount() {
  yield takeEvery(impressionsReportsModule.fetchImpressionsCount.getType(), fetchImpressionsCount);
}

export function* fetchImpressionsAllCountries() {
  const filter = yield select(state => state.impressionsReports.filter);
  const sort = yield select(state => state.impressionsReports.allCountries.sort);

  const { response, error } = yield call(Api.impressionsReports.fetchImpressionsAllCountries, { filter, sort });

  if (response) {
    yield put(impressionsReportsModule.fetchImpressionsAllCountriesSuccess(response));
  } else {
    yield put(impressionsReportsModule.fetchImpressionsAllCountriesFail(error));
  }
}
export function* watchFetchImpressionsAllCountries() {
  yield takeEvery(impressionsReportsModule.fetchImpressionsAllCountries.getType(), fetchImpressionsAllCountries);
}

export function* fetchImpressionsAllCampaigns() {
  const filter = yield select(state => state.impressionsReports.filter);
  const sort = yield select(state => state.impressionsReports.allCampaigns.sort);

  const { response, error } = yield call(Api.impressionsReports.fetchImpressionsAllCampaigns, { filter, sort });

  if (response) {
    yield put(impressionsReportsModule.fetchImpressionsAllCampaignsSuccess(response));
  } else {
    yield put(impressionsReportsModule.fetchImpressionsAllCampaignsFail(error));
  }
}
export function* watchFetchImpressionsAllCampaigns() {
  yield takeEvery(impressionsReportsModule.fetchImpressionsAllCampaigns.getType(), fetchImpressionsAllCampaigns);
}

export function* fetchImpressionsStatistics() {
  const filter = yield select(state => state.impressionsReports.filter);

  const { response, error } = yield call(Api.impressionsReports.fetchImpressionsStatistics, { filter });

  if (response) {
    yield put(impressionsReportsModule.fetchImpressionsStatisticsSuccess(response));
  } else {
    yield put(impressionsReportsModule.fetchImpressionsStatisticsFail(error));
  }
}
export function* watchFetchImpressionsStatistics() {
  yield takeEvery(
    impressionsReportsModule.fetchImpressionsStatistics.getType(),
    fetchImpressionsStatistics
  );
}

export default function* watchClicksReports() {
  return yield all([
    fork(watchFetchImpressionsCount),
    fork(watchFetchImpressionsAllCountries),
    fork(watchFetchImpressionsStatistics),
    fork(watchFetchImpressionsAllCampaigns),
  ]);
}



/** WEBPACK FOOTER **
 ** ./js/redux/saga/impressionsReports.saga.js
 **/